import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MainComponent } from "./main.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { routing } from "./main.routing";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { SharedModule } from "../common/shared.modules";
import { UserManagementComponent } from "./user-management/user-management.component";
import { ViewUserComponent } from "./user-management/view-user/view-user.component";
import { UserMgmtService } from "./user-management/user-management.service";
import { DashboardService } from "./dashboard/dashboard.service";
import { ReactiveFormsModule, FormsModule } from "@angular/forms"
import { NgxSpinnerModule } from "ngx-spinner";
import { MyDateRangePickerModule } from "mydaterangepicker";
import { MyDatePickerModule } from "mydatepicker";
import { ContactComponent } from './contact/contact.component';
import { AboutComponent } from './about/about.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { UiSwitchModule } from 'ngx-toggle-switch';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { CourseManagementComponent } from './course-management/course-management.component';
import { ViewCourseComponent } from './course-management/view-course/view-course.component';
import { AddCourseComponent } from './course-management/add-course/add-course.component';
import { EditCourseComponent } from './course-management/edit-course/edit-course.component';
import { PlanManagementComponent } from './plan-management/plan-management.component';
import { ViewPlanComponent } from './plan-management/view-plan/view-plan.component';
import { AddPlanComponent } from './plan-management/add-plan/add-plan.component';
import { EditPlanComponent } from './plan-management/edit-plan/edit-plan.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

import {
  MatToolbarModule,
  MatTableModule,
  MatListModule,
  MatButtonModule
} from '@angular/material';
import { MatDialogModule } from '@angular/material/dialog';
import { DataTableModule } from 'angular7-data-table';
import { MatInputModule } from '@angular/material/input';
import { ViewCourseDetailComponent } from './course-management/view-course-detail/view-course-detail.component';
import { AddCourseDetailComponent } from './course-management/add-course-detail/add-course-detail.component';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { EditCourseDetailComponent } from './course-management/edit-course-detail/edit-course-detail.component';
import { AddAsrComponent } from './course-management/add-asr/add-asr.component';
import { PlanService } from './plan-management/plan.service';
import { CourseManagementService } from './course-management/course-management.service';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { ViewAsrComponent } from './course-management/view-asr/view-asr.component';
import { GeneralConfigurationComponent } from './general-configuration/general-configuration.component';
import { EditConfigurationComponent } from './general-configuration/edit-configuration/edit-configuration.component';
import { GeneralConfiService } from './general-configuration/general-confi.service';
import { NotificationComponent } from './notification/notification.component';
import { NotificationService } from './notification/notification.service';
import { MomentumTableModule } from 'momentum-table';
import { ViewUserCourseComponent } from './user-management/view-user-course/view-user-course.component';
import { ViewUserLessonComponent } from './user-management/view-user-lesson/view-user-lesson.component';
import { ViewUserASRComponent } from './user-management/view-user-asr/view-user-asr.component';
import { Ng5SliderModule } from 'ng5-slider';
import { ReportedQuestionComponent } from './reported-question/reported-question.component';
import { EditAsrComponent } from './course-management/edit-asr/edit-asr.component';
import { ReportedDetailComponent } from './reported-question/reported-detail/reported-detail.component';
import { NgDatepickerModule } from 'ng2-datepicker';
import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS } from 'ngx-slimscroll';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SubscriptionDetailComponent } from './user-management/subscription-detail/subscription-detail.component';
import { PartnerManagementComponent } from './partner-management/partner-management.component';
import { AddPartnerComponent } from './partner-management/add-partner/add-partner.component';
import { EditPartnerComponent } from './partner-management/edit-partner/edit-partner.component';
import { ViewPartnerComponent } from './partner-management/view-partner/view-partner.component';
import { PartnerService } from './partner-management/partner.service';
import { EventManagementComponent } from './event-management/event-management.component';
import { AddEventComponent } from './event-management/add-event/add-event.component';
import { EditEventComponent } from './event-management/edit-event/edit-event.component';
import { ViewEventComponent } from './event-management/view-event/view-event.component';
import { EventService } from "./event-management/event.service";
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ReportingManagementComponent } from './reporting-management/reporting-management.component';
import { ViewComponent } from './reporting-management/view/view.component';
import { DuplicateEventComponent } from './event-management/duplicate-event/duplicate-event.component';
import { ChatSupportComponent } from './user-management/chat-support/chat-support.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxLinkifyjsModule } from 'ngx-linkifyjs';
import { PastEventComponent } from './event-management/past-event/past-event.component';
import { AuditlogComponent } from './view-logs/auditlog/auditlog.component';
import { UserlogsComponent } from './view-user-activity/userlogs/userlogs.component';
import { MainServiceService } from "./main-service.service";
import { AdminTimelogsComponent } from './view-logs/admin-timelogs/admin-timelogs.component';
import { ViewLogsComponent } from './view-logs/view-logs.component';
import { ReportAnswerComponent } from './reported-question/report-answer/report-answer.component';
import { ReportQuestionComponent } from './reported-question/report-question/report-question.component';
import { QuestionDetailComponent } from './reported-question/question-detail/question-detail.component';
import { MonitorLogsComponent } from './view-user-activity/monitor-logs/monitor-logs.component';
import { ViewUserActivityComponent } from './view-user-activity/view-user-activity.component';
import { ExcelService } from "./dashboard/excel.service";
import { ProviderManagementComponent } from "./provider-management/provider-management.component";
import { AddProviderComponent } from "./provider-management/add-provider/add-provider.component";
import { EditProviderComponent } from "./provider-management/edit-provider/edit-provider.component";
import { ViewProviderComponent } from "./provider-management/view-provider/view-provider.component";
import { ProviderService } from "./provider-management/provider.service";
import { OrganizationManagementComponent } from './organization-management/organization-management.component';
import { AddOrganizationComponent } from './organization-management/add/add.component';
import { ViewOrganizationComponent } from './organization-management/view/view.component';
import { BillerCodeComponent } from './provider-management/biller-code/biller-code.component';
import { AddBillerComponent } from './provider-management/add-biller/add-biller.component';
import { EditBillerComponent } from './provider-management/edit-biller/edit-biller.component';
import { ProfileViewComponent } from './organization-management/profile-view/profile-view.component';
import { ChartModule } from 'angular-highcharts';
import { UsersComponent } from './reported-question/users/users.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    PerfectScrollbarModule,
    routing,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    MyDatePickerModule,
    MyDateRangePickerModule,
    NgxChartsModule,
    FormsModule,
    AngularDateTimePickerModule,
    MatToolbarModule,
    MatTableModule,
    UiSwitchModule,
    Ng2SearchPipeModule,
    DragDropModule,
    DataTableModule.forRoot(),
    MatInputModule,
    MatListModule,
    MatButtonModule,
    MatSelectModule,
    MatTabsModule,
    MatIconModule,
    MatDialogModule,
    MatBottomSheetModule,
    NgxSmartModalModule.forRoot(),
    MomentumTableModule,
    Ng5SliderModule,
    MatDatepickerModule,
    NgxMaterialTimepickerModule,
    ImageCropperModule,
    NgSelectModule,
    ChartModule,
    NgxLinkifyjsModule.forRoot(
      {
        enableHash: false, // optional - default true
        enableMention: false // optional - default true
      })

  ],
  declarations: [
    MainComponent,
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    DashboardComponent,
    UserManagementComponent,
    ViewUserComponent,
    ContactComponent,
    AboutComponent,
    CourseManagementComponent,
    ViewCourseComponent,
    AddCourseComponent,
    EditCourseComponent,
    PlanManagementComponent,
    ViewPlanComponent,
    AddPlanComponent,
    EditPlanComponent,
    ViewCourseDetailComponent,
    AddCourseDetailComponent,
    EditCourseDetailComponent,
    AddAsrComponent,
    ViewAsrComponent,
    GeneralConfigurationComponent,
    EditConfigurationComponent,
    NotificationComponent,
    ViewUserCourseComponent,
    ViewUserLessonComponent,
    ViewUserASRComponent,
    ReportedQuestionComponent,
    EditAsrComponent,
    ReportedDetailComponent,
    SubscriptionDetailComponent,
    PartnerManagementComponent,
    AddPartnerComponent,
    EditPartnerComponent,
    ViewPartnerComponent,
    EventManagementComponent,
    AddEventComponent,
    EditEventComponent,
    ViewEventComponent,
    ReportingManagementComponent,
    ViewComponent,
    DuplicateEventComponent,
    ChatSupportComponent,
    PastEventComponent,
    AuditlogComponent,
    UserlogsComponent,
    AdminTimelogsComponent,
    ViewLogsComponent,
    ReportAnswerComponent,
    ReportQuestionComponent,
    QuestionDetailComponent,
    MonitorLogsComponent,
    ViewUserActivityComponent,
    ProviderManagementComponent,
    AddProviderComponent,
    EditProviderComponent,
    ViewProviderComponent,
    OrganizationManagementComponent,
    AddOrganizationComponent,
    ViewOrganizationComponent,
    BillerCodeComponent,
    AddBillerComponent,
    EditBillerComponent,
    ProfileViewComponent,
    UsersComponent
  ],
  providers: [
    UserMgmtService,
    DashboardService,
    PlanService,
    CourseManagementService,
    GeneralConfiService,
    NotificationService,
    PartnerService,
    EventService,
    MainServiceService,
    ExcelService,
    ProviderService,
    
    {
      provide: SLIMSCROLL_DEFAULTS,
      useValue: {
        alwaysVisible: false
      }
    },
  ]
})
export class MainModule { }
